import { HttpParams } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { InspirationRoomOptionModel, InspirationRoomOptionStyle } from "src/app/models/InspirationRoomOptionModel";
import { InspirationRoomModel } from "../../../models/InspirationRoomModel";
import { Globals } from "../../../services/globals";
import { InspirationRoomService } from "../../services/inspiration-rooms/inspiration-room.service";
import { OptionSelectorService } from "../../services/option-selector.service";




@Component({
  templateUrl: './inspirations-report.component.html',
  styleUrls: ['./inspirations-report.component.css']
})

export class InspirationReportComponent {

  inspirationRoom: InspirationRoomModel;
  selectedOptionsForRemove: number[] = [];
  removing: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InspirationRoomModel,
    public dialog: MatDialog,
    public globals: Globals,
    private toastr: ToastrService,
    private service: OptionSelectorService,
    private inspirationRoomService: InspirationRoomService,
  ) { this.inspirationRoom = this.data; }

  get getOptionsList(): InspirationRoomOptionModel[] {
    return this.inspirationRoom.options.sort((a, b) => (a.displayName < b.displayName) ? -1 : 1);;
  }
  inactive(option: InspirationRoomOptionModel) {
    return !this.globals.getAllGobalOption().some(x => x.optionId == option.optionId);
  }
  optionSelected(optionId: number) {
    if (this.selectedOptionsForRemove && this.selectedOptionsForRemove.length) {
      if (this.selectedOptionsForRemove.includes(optionId)) {
        this.selectedOptionsForRemove = this.selectedOptionsForRemove.filter(x => x !== optionId);
      } else {
        this.selectedOptionsForRemove.push(optionId)
      }
    } else {
      this.selectedOptionsForRemove = []
      this.selectedOptionsForRemove.push(optionId)
    }
  }

  get showRemoveBtn(): boolean {
    return this.selectedOptionsForRemove && this.selectedOptionsForRemove.length ? true : false;
  }

  removeSelectedOption() {
    this.removing = true;
    let model = {
      optionIds: this.selectedOptionsForRemove,
      roomId: this.inspirationRoom.id
    }
    this.service.deleteMultipleOptions(model).subscribe(success => {
      if (success) {
        this.service.refreshDeletedOption(this.selectedOptionsForRemove);
        this.removing = false;
        this.toastr.success("Selected option have been removed successfully", "SUCCESS")
        this.dialog.closeAll()
      } else {
        this.removing = false;
        this.toastr.warning("Selected option not removed successfully", "WARNING")
      }
    }, error => {
      this.removing = false;
      this.toastr.error("Something went wrong, please try again", "ERROR")
    });
  }

  getStyles(option: InspirationRoomOptionModel): string {
    let styleSelections = option.styleSelections;
    if (styleSelections.some(x => x.styleId > 0 && x.style)) {
      let selectedStyles = [];
      for (let style of styleSelections) {
        let isActive = true;
        if (style.styleId > 0) {
          if (this.globals.getAllGobalOption().some(x => x.optionId == option.optionId)) {
            let globalOption = this.globals.getAllGobalOption().find(x => x.optionId == option.optionId)
            if (!globalOption.styleSelections.some(x => x.optionId == style.styleSelectionId)) {
              isActive = false
            } else {
              let currentActiveColorList = globalOption.styleSelections.find(x => x.optionId == style.styleSelectionId)
              if (!currentActiveColorList.styleChoices.some(x => x.optionId == style.styleId)) {
                isActive = false;
              }
            }
          } else {
            isActive = false
          }
        }
        let styleHtml = `<i${!isActive ? ' class="text-danger"' : ""}>${style.style != undefined ? style.style :""}</i>`
        if (style.style != undefined)
        selectedStyles.push(styleHtml);
      }
      return ' : ' + selectedStyles.join(", ").trim();
    } return null;
  }

  exportInspirationRoom(selectedRoom) {
    const params = new HttpParams()
      .set("roomId", this.inspirationRoom.id);
    this.inspirationRoomService.exportInspirationRooms(params).subscribe(result => {
      const detailedReport: any = result.data;
      const linkSource = 'data:application/pdf;base64,' + detailedReport;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = result.fileName;
      downloadLink.click();
    });
  }
}
